module.exports = __webpack_public_path__ + "static/img/enterprise3.9d1b274d.png";